import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DepartmentSchema, type CreateDepartmentInput, type Department } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useCreateDepartment() {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<Department, unknown, CreateDepartmentInput>({
    mutationFn: (input) => client.post<Department>('/departments', input, {}, DepartmentSchema),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['departments', 'list'] }),
  });
}
